import { captureScreenshot } from "./screenshot.js";
import { collectMetadata } from "./metadata.js";
export class AssaySDK {
    apiKey;
    endpoint;
    constructor(config) {
        if (!config.apiKey || config.apiKey.trim() === "") {
            throw new Error("AssaySDK: apiKey must be a non-empty string");
        }
        if (!config.endpoint || config.endpoint.trim() === "") {
            throw new Error("AssaySDK: endpoint must be a non-empty string");
        }
        this.apiKey = config.apiKey;
        this.endpoint = config.endpoint;
    }
    /**
     * Create an AssaySDK instance from environment variables (Node.js / SSR).
     * Reads ASSAY_API_KEY and ASSAY_ENDPOINT from process.env.
     *
     * In Vite browser apps, Vite substitutes import.meta.env at build time,
     * so pass values directly to the constructor:
     *   new AssaySDK({ apiKey: import.meta.env.VITE_ASSAY_API_KEY, endpoint: import.meta.env.VITE_ASSAY_ENDPOINT })
     */
    static fromEnv() {
        const env = typeof process !== "undefined" ? process.env : {};
        const apiKey = env["ASSAY_API_KEY"] ?? env["VITE_ASSAY_API_KEY"] ?? "";
        const endpoint = env["ASSAY_ENDPOINT"] ?? env["VITE_ASSAY_ENDPOINT"] ?? "";
        return new AssaySDK({ apiKey, endpoint });
    }
    async capture(options = {}) {
        const [screenshot, meta] = await Promise.all([captureScreenshot(), collectMetadata()]);
        const payload = {
            captured_at: meta.capturedAt,
            url: meta.url,
            viewport: meta.viewport,
            user_agent: meta.userAgent,
            screenshot,
            user_comment: options.comment ?? null,
            metadata: {},
        };
        if (options.taskId !== undefined)
            payload["task_id"] = options.taskId;
        if (options.verificationId !== undefined)
            payload["verification_id"] = options.verificationId;
        payload["kind"] = options.kind ?? "report";
        const ingestUrl = this.endpoint.replace(/\/$/, "") + "/ingest";
        const response = await fetch(ingestUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Assay-Key": this.apiKey,
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            let detail = "";
            try {
                const body = await response.json();
                if (body && typeof body.detail === "string")
                    detail = `: ${body.detail}`;
            }
            catch { /* non-JSON body */ }
            throw new Error(`AssaySDK: ingest request failed with status ${response.status}${detail}`);
        }
        return response.json();
    }
}
//# sourceMappingURL=sdk.js.map